import { useState } from 'react'
import { captureFrontendError } from './captureFrontendError'

export const useThrowErrorAndRenderErrorBoundary = (logErrorToSentry = false) => {
  const [error, setError] = useState<unknown>(null)

  if (error) {
    if (logErrorToSentry) captureFrontendError(error)

    throw error
  }

  return (err: unknown) => setError(err)
}
